
import React from 'react';
import { Button } from '@/components/ui/button';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '@/components/ui/card';
import { Textarea } from '@/components/ui/textarea';
import { Save } from 'lucide-react';

interface TechniqueNotesCardProps {
  notes: string;
  isAuthenticated: boolean;
  isSavingNotes: boolean;
  initialNotes: string;
  onNotesChange: (e: React.ChangeEvent<HTMLTextAreaElement>) => void;
  onSaveNotes: () => void;
}

export const TechniqueNotesCard: React.FC<TechniqueNotesCardProps> = ({
  notes,
  isAuthenticated,
  isSavingNotes,
  initialNotes,
  onNotesChange,
  onSaveNotes,
}) => {
  return (
    <Card>
      <CardHeader>
        <CardTitle className="text-xl">Personal Notes</CardTitle>
        <CardDescription>Add your own notes and reminders about this technique</CardDescription>
      </CardHeader>
      <CardContent className="space-y-4">
        <Textarea 
          placeholder={isAuthenticated ? "Add your personal notes here..." : "Please sign in to add notes"}
          value={notes}
          onChange={onNotesChange}
          className="min-h-[120px] resize-y"
          disabled={!isAuthenticated}
        />
        
        <div className="flex justify-end">
          <Button 
            onClick={onSaveNotes} 
            disabled={!isAuthenticated || isSavingNotes || notes === initialNotes}
            className="gap-2"
          >
            <Save className="h-4 w-4" />
            Save Notes
          </Button>
        </div>
      </CardContent>
    </Card>
  );
};
